import { MarkupTooltipStyleClass } from '@tableau/data-catalog-client-components';
import { TextAreaProps, TextAreaWidget,TextFormatterProps, TextFormatterWidget } from '@tableau/widgets';
import React from 'react';


export type TextFormatterOrAreaWidgetProps = {
  id: string;
  useFormatter?: boolean;
  style?: React.HTMLAttributes<HTMLTextAreaElement>;
} & TextFormatterProps & TextAreaProps;

export function TextFormatterOrAreaWidget(props: TextFormatterOrAreaWidgetProps): React.ReactElement {
  const { markup, ...restProps } = props;
  const useFormatter = props.useFormatter?? true;

  return (
    useFormatter ?
      <TextFormatterWidget
        {...restProps}
        markup={markup}
        previewClassName={MarkupTooltipStyleClass}
      /> :
      <TextAreaWidget
        {...restProps}
        value={markup}
      />
  );
}
